export class Keyframe2D {
    clone() {
        var dest = new Keyframe2D();
        this.cloneTo(dest);
        return dest;
    }
    cloneTo(destObject) {
        destObject.time = this.time;
    }
}
Keyframe2D.defaultWeight = 0.33333;
